// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
// import iView from 'iview'
import { Button, Modal, FormItem, Form, Input, Select, Option, Carousel, CarouselItem, Icon, DatePicker, Table, Message, Row, Col } from 'iview'
import i18n from './translations/i18n'
import axios from './axios/index.js'
import Moment from 'moment'
import './styles/index.styl'
import 'iview/dist/styles/iview.css'
import UTILS from '@/utils/index.js'
import myHeader from '@/components/basic/MyHeader'
import iconButton from '@/components/basic/IconButton'
import myFooter from '@/components/basic/MyFooter'
import consultationModal from '@/components/basic/ConsultationModal'
import title from './components/basic/Title'
import { sha256 } from 'js-sha256'
import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

Vue.config.productionTip = false
Vue.prototype.UTILS = UTILS

// iview的安装
// Vue.use(iView)
// moment的使用
Vue.prototype.$moment = Moment
Moment.locale('zh-cn')
Vue.filter('time', function (data, fromatStr) { // 转换时间格式
  return Moment(data).format(fromatStr)
})
Vue.filter('timeFromNow', function (previousTime) { // 显示相对时间
  return Moment(previousTime).fromNow(previousTime)
})
//axios的引入
axios.defaults.baseURL = SERVICE_URL
Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, 'sha256', { value: sha256 })
// 全局组件引入
Vue.component(title.name, title)
Vue.component(myHeader.name, myHeader)
Vue.component(myFooter.name, myFooter)
Vue.component(iconButton.name, iconButton)
Vue.component(consultationModal.name, consultationModal)
Vue.component('Button', Button)
Vue.component('Modal', Modal)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Input', Input)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('Carousel', Carousel)
Vue.component('CarouselItem', CarouselItem)
Vue.component('Icon', Icon)
Vue.component('DatePicker', DatePicker)
Vue.component('Table', Table)
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.prototype.$Message = Message

// 跳转后回滚到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
// 跳转前替换标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  } else {
    let map = {
      power: '电力行业',
      teach: '教育行业',
      energy: '能源行业',
      traffic: '交通行业',
      port: '制造行业',
      video: '音视频分析'
    }
    document.title = map[to.params.type] + ' - TitanOS'
  }
  next()
})
//兼容性
/* eslint-disable no-new */
document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#app',
    router,
    i18n: i18n,
    components: { App },
    template: '<App/>'
  })
})


// WEBPACK FOOTER //
// ./src/main.js